import React from "react";
var __jsx = React.createElement;
import stl from "./ShapeCheckBox.module.css";
var ShapeCheckBox = function ShapeCheckBox(_ref) {
  var name = _ref.name,
    count = _ref.count,
    image = _ref.image,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    checked = _ref.checked;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " ").concat(disabled ? stl.disabled : ""),
    "data-disabled": disabled
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: onChange,
    checked: checked
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "car shape"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.nameContainer
  }, /*#__PURE__*/React.createElement("span", null, name), " ", /*#__PURE__*/React.createElement("span", {
    className: stl.count
  }, "(", count, ")")))));
};
export default ShapeCheckBox;